import { translate } from '../../Internationalization';
import convertNumberToFormattedString from '../../../utils/convertNumberToFormattedString';
import formatCentsForDisplay from '../../../utils/formatCentsForDisplay';
import formatDateForDisplay from '../../../utils/formatDateForDisplay';
import React from 'react';

/** @type {React.CSSProperties} */
const propertyCardStyle = {
	background: '#ffffff',
	border: '1px solid transparent',
	borderRadius: '0.9rem',
	boxSizing: 'border-box',
	marginBottom: '4px',
	padding: '0.9rem 1rem',
	transform: 'scale(1)',
	transition:
		'transform 220ms cubic-bezier(0.22, 1, 0.36, 1), border 220ms ease, box-shadow 220ms ease, background 220ms ease',
};

/** @type {React.CSSProperties} */
const highlightedPropertyCardStyle = {
	background: '#fcfdff',
	border: '1px solid #111111',
	boxShadow: '0 4px 10px rgba(42, 108, 207, 0.05)',
	transform: 'scale(0.985)',
};

export default class ComparableMarketProperty extends React.Component {
	render() {
		const address = this.props.comparable.location.address;

		const status =
			this.props.comparable.status === 'available'
				? 'listed'
				: this.props.comparable.status;

		return (
			<li
				className="list-item"
				style={{
					...propertyCardStyle,
					...(this.props.isHighlighted
						? highlightedPropertyCardStyle
						: {}),
				}}
			>
				<h4 className="h-ms">
					{address.substring(0, address.length - 6)}
				</h4>

				<div className="-text-ms-2 mt-1.5">
					{this.props.comparable.property.bedroomCount}
					{translate('homeowner.pages.finances.view.market.bedrooms')}
					{', '}
					{this.props.comparable.property.bathroomCount}
					{translate(
						'homeowner.pages.finances.view.market.bathrooms'
					)}
					{', '}
					{convertNumberToFormattedString(
						this.props.comparable.property.squareFootage
					)}
					{translate(
						'homeowner.pages.finances.view.market.square_feet'
					)}
				</div>

				<div className="-text-ms-1 mt-1.5 font-bold text-black">
					{formatCentsForDisplay(
						(this.props.comparable.price ?? 0) * 100,
						0
					)}
				</div>

				<div className="justified-row mt-1.5">
					<div className="-text-ms-1 font-bold text-theme-accent">
						{translate(
							`homeowner.pages.finances.view.market.${status}`
						)}{' '}
						{formatDateForDisplay(this.props.comparable.date)}
					</div>
				</div>
			</li>
		);
	}
}
